export class TimeCountDown {
  constructor(
      public timeToObserveBeforeStart: number,
      public isCountDownVisible: boolean
    ) {}
}
